import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getServiceDeskNavigationResources,
	getServicedeskPageContextResources,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { servicedeskProjectSummaryRoute } from '@atlassian/jira-router-routes-servicedesk-project-summary-routes/src/servicedeskProjectSummaryRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import {
	APP_NAMES,
	toPackageName,
} from '@atlassian/jira-servicedesk-common/src/utils/app-names/index.tsx';
import { ProjectSummarySkeleton } from '@atlassian/jira-skeletons/src/ui/servicedesk/project-summary/ProjectSummarySkeleton.tsx';
import { getProjectSummaryFilterFieldsResource } from '@atlassian/jira-router-resources-service-desk-project-summary/src/services/filters/index.tsx';
import { summaryPageViewsResource } from '@atlassian/jira-router-resources-service-desk-project-summary/src/services/views/index.tsx';
import { AsyncJSMProjectSummaryHorizontalNav } from '@atlassian/jira-navigation-apps-horizontal-nav-jsm-project-summary/src/index.tsx';
import { projectSummaryPageEntryPoint } from './ui/index.tsx';

export const servicedeskProjectSummaryRouteEntry = createEntry(
	servicedeskProjectSummaryRoute,
	() => ({
		group: 'servicedesk',
		ufoName: 'jsm.project-summary',
		component: () => null,
		skeleton: ProjectSummarySkeleton,

		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarServicedesk,
			horizontal:
				// eslint-disable-next-line jira/ff/no-preconditioning
				fg('jsm_project_summary_avp') && fg('jsm_project_summary_avp_m1')
					? AsyncJSMProjectSummaryHorizontalNav
					: undefined,
		},

		layout: serviceProjectLayout,

		resources: [
			...getServiceDeskNavigationResources(),
			...getServicedeskPageContextResources(),
			getConsolidationStateResource(),
			resourceWithCondition2(
				() => !fg('jsm_project_summary_avp'),
				getProjectSummaryFilterFieldsResource(),
			),
			resourceWithCondition2(
				() => !__SERVER__ && fg('jsm_project_summary_avp'),
				summaryPageViewsResource,
			),
		],

		entryPoint: () => projectSummaryPageEntryPoint,

		meta: {
			reporting: {
				id: 'project-summary',
				packageName: toPackageName(APP_NAMES.PROJECT_SUMMARY),
				teamName: 'jsd-shield',
			},
		},

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-servicedesk-project-summary-entries/src/servicedeskProjectSummaryRouteEntry.tsx',
				whichExportToUse: 'servicedeskProjectSummaryRouteEntry',
			},

			enabled: true,
		},
	}),
);
